import { User } from "@fairfleet/geotab";

/** Geotab's built-in "Administrator" security clearance. */
const ADMINISTRATOR_SECURITY_GROUP_ID = "GroupEverythingSecurityId";

export function isAdministrator(user: User | null | undefined): boolean {
  return !!user?.securityGroups?.some(group => group.id === ADMINISTRATOR_SECURITY_GROUP_ID);
}
